export const pretFoundationPath = 'the-pret-foundation'
export const risingStarsPath = 'rising-stars'
export const clickAndCollectShutterPathUK = 'click-and-collect/unavailable'
export const clickAndCollectShutterPathUS = 'pick-up/unavailable'
export const listUserToBeSubscribe = ['new', 'cancelled']
export const PRET_DELIVERS_SHOP_ASSIGNMENT = '/pret-delivers/address'
